<template>
  <div>
    <Header />
    <div class="personalServicesHome">
      <!-- <Nav /> -->
      <div class="container">
        <div class="serverList">
          <div
            v-if="$showEdu"
            class="serverItem"
            @click="handleRedirect('/educational/index')"
          >
            <i class="serverIcon icon_pi"></i>
            <div>教育{{ $eduType }}管理</div>
          </div>
          <div
            class="serverItem"
            @click="handleRedirect('/educational/classList')"
          >
            <i class="serverIcon icon_pir"></i>
            <div>班期与学生管理</div>
          </div>
          <div
            class="serverItem"
            @click="handleRedirect('/educational/incidentList')"
          >
            <i class="serverIcon icon_rc"></i>
            <div>活动/事件管理</div>
            <!-- <div class="hasNew"><i class="icon_alert"></i>有新的申请</div> -->
          </div>
          <div
            class="serverItem"
            @click="handleRedirect('/educational/corrigendaList')"
          >
            <i class="serverIcon icon_co"></i>
            <div>勘误申请处理</div>
          </div>
        </div>
      </div>
      <div class="bg_bottom"></div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Nav from "@/components/Nav.vue";
import { educationalType } from "@/utils/mixins";
import { mapGetters } from "vuex";
export default {
  components: { Header, Nav, Footer },
  computed: { ...mapGetters(["userInfo"]) },
  mixins: [educationalType],
  mounted(){
    if(this.userInfo.businessAdmin){
      // console.log('push');
      this.$router.push('/educationalAdmin/staff')
    }
  },
  methods: {
    handleRedirect(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss" scoped>
.personalServicesHome {
  background-color: #c9d4eb;
  .serverList {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 191px 0 211px 0;
    .serverItem {
      position: relative;
      width: 245.9px;
      height: 249px;
      margin-right: 47px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: #3a61b1;
      font-size: 20px;
      font-weight: bold;
      background: #fff;
      border-radius: 8px;
      cursor: pointer;
      &:hover {
        box-shadow: 0 0 10px 0 rgba(58, 97, 177, 0.52);
      }
      .serverIcon {
        width: 72.8px;
        height: 66px;
        display: inline-block;
        background-size: cover !important;
        margin-bottom: 28px;
      }
      .icon_pi {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_ed1.png")
          no-repeat;
      }
      .icon_pir {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_ed2.png")
          no-repeat;
      }
      .icon_rc {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_ed3.png")
          no-repeat;
      }
      .icon_co {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_ed4.png")
          no-repeat;
      }
      .icon_alert {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_alert.png")
          no-repeat;
        background-size: cover;
        width: 12px;
        height: 15px;
        display: inline-block;
        margin-right: 6px;
        vertical-align: middle;
      }
      .hasNew {
        font-size: 16px;
        color: #6e6e6e;
        margin-top: 16px;
        position: absolute;
        bottom: 34px;
        margin-right: 7px;
      }
    }
  }
  .bg_bottom {
    height: 92px;
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/bg_bottom.png")
      no-repeat;
    background-size: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/educationalServicesHome/index.vue